import { validationRules } from "../../utils/validation";

export const riskAssesmentcontinuedInfoSchema = {
    UKpep: [
        validationRules.required("Is the client/counterparty or beneficial owner a UK PEP? is required"),
    ],

    PepType:[validationRules.required("What type of PEP is this? * is required")],
   
    PepJurisdiction: [
        validationRules.required("What Jurisdiction is this PEP in?* is required"),
    ],
    PepDescription: [
        validationRules.required("Please provide a description of the PEP* is required"),
    ],

    Aliases: [
        validationRules.required("Aliases (if any): is required"),
    ],
    SanctionedYear: [
        validationRules.required("What year was the individual Sanctioned in? is required"),
    ],
     
    sanctionReason: [
        validationRules.required("What is the reason for the sanction? * required"),
    ],
    UKsanctioned: [
        validationRules.required("Is this individual/entity sanctioned in the UK? * is required"),
    ],

    mitigatingFactors: [
        validationRules.required("Are there any mitigating factors that suggest the match is incorrect or low risk? is required"),
    ],

    FactorDetails: [
        validationRules.required("Please provide details of the mitigating factors: is required"),  
    ],
   
    knownCovenant: [
        validationRules.required("knownCovenant is required"),
    ],
    
    // operatingYear: [  validationRules.required("How long has this entity been operating in this sector? (in years)is required")

    // ],
    unwillingInformation: [  validationRules.required("What specific information or documents has the client/counterparty been unwilling to provide?is required")
        
    ],
    DelayReason: [  validationRules.required("Have they given a reason for this delay? is required")
        
    ],
    RequestMissingInfo: [  validationRules.required("How many requests have you made for the missing information/documents? (Include dates or frequency of followup) is required")
        
    ],
    timeframe: [  validationRules.required("What specific timeframe has the client/counterparty requested for completion? is required")
        
    ],
    urgencyReason: [  validationRules.required("Has the client/counterparty provided a reason for the urgency? is required")
        
    ],
    urgencyEvent: [  validationRules.required("Is there any indication that the urgency may be linked to a significant event? (e.g., year-end, regulatory changes, etc.) is required")
        
    ],

    adverseInformation: [  validationRules.required("What specific adverse information did your searches reveal? (Please Summarise) is required")
        
    ],
   
    coverageSource: [  validationRules.required("What is the source of the coverage?  is required")
        
    ],

    coverageDetail: [  validationRules.required("Please provide details of the coverage: is required")  ],
   
    adversePublicity: [  validationRules.required("Has the client/counterparty directly addressed the adverse publicity with you during the course of your engagement? is required")
        
    ],
   
    findingsInvestigation: [  validationRules.required("Do you believe these findings warrant escalation or further internal investigation? is required")
        
    ],
   
    offenseNature: [  validationRules.required("What was the nature of the offense? is required")
        
    ],
   
    OffenceReason: [  validationRules.required("Indicate the reason why:* is required")
        
    ],
    
    whiteCollarOffence: [  validationRules.required("Was this a “white-collar” offence?* is required")
        
    ],
    
    proceedingsVoluntarily: [  validationRules.required("Did the client/counterparty disclose the proceedings voluntarily? is required")
        
    ],
    
    reputationalConcerns: [  validationRules.required("Do the proceedings indicate an elevated financial crime risk or potential reputational concerns relevant to this transaction? is required")
        
    ],
    
    subjectAllegations: [  validationRules.required("Has the client/ counterparty previously been subject to allegations involving tax avoidance or evasion? is required")
        
    ],
   
    AllegationsDetails : [  validationRules.required("Please provide details of the allegations: is required")  ],
   
}
